import actionTypes from './actionTypes';

export const userDropdownShow = () => ({
    type: actionTypes.USER_DROPDOWN_SHOW
});

export const userDropdownHide = () => ({
    type: actionTypes.USER_DROPDOWN_HIDE
});
